import React, { Suspense } from "react";
import type { AddressInputProps } from "./AddressInputInner";

const LazyAddressInput = React.lazy(() =>
  import("./AddressInputInner").then((mod) => ({
    default: mod.default,
  })),
);

export type { AddressInputProps, AddressValue } from "./AddressInputInner";

export function AddressInput(props: AddressInputProps) {
  return (
    <Suspense
      fallback={
        <div className="space-y-4">
          <div className="h-10 w-full rounded-md bg-gray-100 animate-pulse" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="h-10 w-full rounded-md bg-gray-100 animate-pulse" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="h-10 w-full rounded-md bg-gray-100 animate-pulse" />
            <div className="h-10 w-full rounded-md bg-gray-100 animate-pulse" />
            <div className="h-10 w-full rounded-md bg-gray-100 animate-pulse" />
          </div>
        </div>
      }
    >
      <LazyAddressInput {...props} />
    </Suspense>
  );
}
